import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../base/dialog/dialog";
import { Button } from "../../base/button/button";
/**
 * Reusable delete confirmation dialog
 *
 * @example
 * ```tsx
 * <DeleteConfirmDialog
 *   open={deleteDialogOpen}
 *   onOpenChange={setDeleteDialogOpen}
 *   onConfirm={() => deleteMutation.mutate(id)}
 *   isDeleting={deleteMutation.isPending}
 *   entityPhrase={t("organization.departments.deletePhrase")}
 * />
 * ```
 */ export function DeleteConfirmDialog({ open, onOpenChange, onConfirm, title, description, isDeleting = false, entityPhrase }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: (next)=>{
            if (!next && isDeleting) return;
            onOpenChange(next);
        },
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            children: [
                /*#__PURE__*/ _jsxs(DialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            children: title || t("common.confirmDelete")
                        }),
                        /*#__PURE__*/ _jsx(DialogDescription, {
                            children: description || t("common.confirmDeleteDescription", {
                                entity: entityPhrase
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(DialogFooter, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "outline",
                            onClick: ()=>onOpenChange(false),
                            disabled: isDeleting,
                            children: t("common.cancel")
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "destructive",
                            onClick: onConfirm,
                            loading: isDeleting,
                            children: t("common.delete")
                        })
                    ]
                })
            ]
        })
    });
}

//# sourceMappingURL=delete-confirm-dialog.js.map